import { useFormik } from 'formik';
import { Input, InputGroup, Form, Loader, Rate, InputPicker } from 'rsuite';
import * as Yup from 'yup';

import { useEffect, useState } from 'react';

import FieldWithDebounce from "../forms/DebounceField";
import Field from "../forms/Field";

import SearchIcon from '@rsuite/icons/Search';

import CheckOutlineIcon from '@rsuite/icons/CheckOutline';
import CloseOutlineIcon from '@rsuite/icons/CloseOutline';
import { createBrief, get_info_by_inn, getBrief, updateBriefField, updateBriefFields } from './briefCreationManager';

import { renderItem as renderBriefDataItem } from './briefCreateFormRenderData';
import Sections from './sotrable/Sections';

const EXPERTISE_TYPES = [
    { label: 'Экологический аудит', value: 1 },
    { label: 'ПДВ', value: 2 },
    { label: 'НМУ', value: 3 },
    { label: 'СЗЗ', value: 4 },
    { label: 'ОВЕС', value: 5 },
]

const INN_FIELDS = {
    org_name: '',
    address: '',
    OKVED: '',
    OKTMO: '',
    OGRN: '',
    KPP: '',
    FIO: '',
}

const validationSchema = Yup.object().shape({
    expertise_type: Yup.number().required('Тип экспертизы обязателен для заполнения'),
});

export default function BriefCreateForm() {
    const [loadingINN, setLoadingINN] = useState(false);
    const [creating, setCreating] = useState(false);
    const [briefData, setBriefData] = useState([]);

    const ExpertiseTypeInput = ({...props}) => {
        return (
            <InputPicker {...props} data={EXPERTISE_TYPES} style={{width: '100%'}}/>
        )
    }

    const InnInput = ({...props}) => {
        return (
            <InputGroup style={{width: '100%'}} inside>
                <Input {...props} style={{width: '100%'}}/>
                <InputGroup.Addon>
                    {
                        loadingINN ?
                        <Loader speed="slow" /> :
                        formik.values.org_name ?
                        <CheckOutlineIcon color='green' /> :
                        formik.values.INN ?
                        <CloseOutlineIcon color='red' /> :
                        <SearchIcon />
                    }
                </InputGroup.Addon>
            </InputGroup>
        )
    }

    const formik = useFormik({
        initialValues: {
            name: '',
            INN: '',
            expertise_type: 1,
            ...INN_FIELDS
        },
        validationSchema
    });

    useEffect(() => {
        if (localStorage.getItem('brief:current_edit')) {
            const id = localStorage.getItem('brief:current_edit');

            getBrief(id, setBriefData, formik);
        }
    }, []);

    useEffect(() => {
    }, [loadingINN]);

    useEffect(() => {
        if (!creating) return;

        createBrief(formik.values, setBriefData);
        setCreating(false);
    }, [creating]);

    useEffect(() => {
        console.log(briefData)
    }, [briefData]);

    return (
        <>
        <Form>
            <FieldWithDebounce // NAME
                handleDebouncedAction={(e) => {
                    updateBriefField(localStorage.getItem('brief:current_edit'), 'name', e)
                }}
                onChange={(e) => {
                    formik.setFieldValue('name', e);
                }}
            >
                <Field
                    className="form-small-margin"
                    as={Input}
                    name="name"
                    label="Название"
                    value={formik.values.name}
                    error={formik.errors.name}
                />
            </FieldWithDebounce>
            
            <FieldWithDebounce // NAME
                handleDebouncedAction={(e) => {
                    updateBriefField(localStorage.getItem('brief:current_edit'), 'expertise_type', e)
                }}
                onChange={(e) => {
                    formik.setFieldValue('expertise_type', e);
                }}
            >
                <Field
                    className="form-small-margin"
                    as={ExpertiseTypeInput}
                    name="expertise_type"
                    label="Тип экспертизы"
                    value={formik.values.expertise_type}
                    error={formik.errors.expertise_type}
                />
            </FieldWithDebounce>

            <FieldWithDebounce // ИНН
                handleDebouncedAction={(e) => {
                    if (localStorage.getItem('brief:current_edit')) {
                        updateBriefField(localStorage.getItem('brief:current_edit'), 'INN', e)
                        get_info_by_inn(e, setLoadingINN,
                            (data) => updateBriefFields(localStorage.getItem('brief:current_edit'), data),
                            formik, false
                        )
                    } else {
                        get_info_by_inn(e, setLoadingINN, setCreating, formik)
                    }
                    
                }}
                onChange={(e) => {
                    setLoadingINN(true);
                    formik.setFieldValue('INN', e);

                    Object.entries(INN_FIELDS).forEach(([key, value]) => {
                        formik.setFieldValue(key, '');
                    });
                }}
            >
                <Field
                    as={InnInput}
                    name="INN"
                    label="ИНН"
                    placeholder="ИНН"
                    value={formik.values.INN}
                    error={formik.errors.INN}
                />
            </FieldWithDebounce>
            
            {formik.values.org_name &&
            <FieldWithDebounce // ORG_NAME
                handleDebouncedAction={(e) => {
                    updateBriefField(localStorage.getItem('brief:current_edit'), 'org_name', e)
                }}
                onChange={(e) => {
                    formik.setFieldValue('org_name', e);
                }}
            >
                <Field
                    className="form-small-margin"
                    as={Input}
                    name="org_name"
                    label="Наименование"
                    value={formik.values.org_name}
                    error={formik.errors.org_name}
                />
            </FieldWithDebounce>
            }

            {formik.values.address &&
            <FieldWithDebounce // ORG_NAME
                handleDebouncedAction={(e) => {
                    updateBriefField(localStorage.getItem('brief:current_edit'), 'address', e)
                }}
                onChange={(e) => {
                    formik.setFieldValue('address', e);
                }}
            >
                <Field
                    className="form-small-margin"
                    as={Input}
                    name="address"
                    label="Адрес"
                    value={formik.values.address}
                    error={formik.errors.address}
                />
            </FieldWithDebounce>
            }

            {formik.values.OGRN &&
            <FieldWithDebounce // OGRN
                handleDebouncedAction={(e) => {
                    updateBriefField(localStorage.getItem('brief:current_edit'), 'OGRN', e)
                }}
                onChange={(e) => {
                    formik.setFieldValue('OGRN', e);
                }}
            >
                <Field
                    className="form-small-margin"
                    as={Input}
                    name="OGRN"
                    label="ОГРН"
                    value={formik.values.OGRN}
                    error={formik.errors.OGRN}
                />
            </FieldWithDebounce>
            }

            {formik.values.KPP &&
            <FieldWithDebounce // KPP
                handleDebouncedAction={(e) => {
                    updateBriefField(localStorage.getItem('brief:current_edit'), 'KPP', e)
                }}
                onChange={(e) => {
                    formik.setFieldValue('KPP', e);
                }}
            >
                <Field
                    className="form-small-margin"
                    as={Input}
                    name="KPP"
                    label="КПП"
                    value={formik.values.KPP}
                    error={formik.errors.KPP}
                />
            </FieldWithDebounce>
            }

            {formik.values.OKVED &&
            <FieldWithDebounce // OKVED
                handleDebouncedAction={(e) => {
                    updateBriefField(localStorage.getItem('brief:current_edit'), 'OKVED', e)
                }}
                onChange={(e) => {
                    formik.setFieldValue('OKVED', e);
                }}
            >
                <Field
                    className="form-small-margin"
                    as={Input}
                    name="OKVED"
                    label="ОКВЭД"
                    value={formik.values.OKVED}
                    error={formik.errors.OKVED}
                />
            </FieldWithDebounce>
            }
            
            {formik.values.OKTMO &&
            <FieldWithDebounce // OKTMO
                handleDebouncedAction={(e) => {
                    updateBriefField(localStorage.getItem('brief:current_edit'), 'OKTMO', e)
                }}
                onChange={(e) => {
                    formik.setFieldValue('OKTMO', e);
                }}
            >
                <Field
                    className="form-small-margin"
                    as={Input}
                    name="OKTMO"
                    label="ОКТМО"
                    value={formik.values.OKTMO}
                    error={formik.errors.OKTMO}
                />
            </FieldWithDebounce>
            }

            {formik.values.FIO &&
            <FieldWithDebounce // FIO
                handleDebouncedAction={(e) => {
                    updateBriefField(localStorage.getItem('brief:current_edit'), 'FIO', e)
                }}
                onChange={(e) => {
                    formik.setFieldValue('FIO', e);
                }}
            >
                <Field
                    className="form-small-margin"
                    as={Input}
                    name="FIO"
                    label="ФИО Руководителя"
                    value={formik.values.FIO}
                    error={formik.errors.FIO}
                />
            </FieldWithDebounce>
            }
        </Form>

        {   
            briefData.length > 0 &&
            <Sections items={briefData} setItems={setBriefData}/>
        }
        </>
    )
}